import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-teams-style-snackbar',
  templateUrl: './teams-style-snackbar.component.html',
  styleUrls: ['./teams-style-snackbar.component.scss']
})
export class TeamsStyleSnackbarComponent {
  reply = '';

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackbar : MatSnackBar,
    public snackBarRef: MatSnackBarRef<TeamsStyleSnackbarComponent>
  ) {}

  sendReply() {
    console.log('User reply:', this.reply);
    this.close();
  }

  close() {
    this.snackBarRef.dismiss();
  }
    onSnooze() {
    this.snackBarRef.dismiss();
    setTimeout(() => {
      this.snackbar.openFromComponent(TeamsStyleSnackbarComponent, {
        data: this.data,
        panelClass: ['teams-snackbar-panel'],
        duration: 4000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
      });
    }, 300000); // 5 minutes in milliseconds
  }
}